import { render, staticRenderFns } from "./user_item_step_devices.vue?vue&type=template&id=453d6853"
import script from "./user_item_step_devices.vue?vue&type=script&lang=js"
export * from "./user_item_step_devices.vue?vue&type=script&lang=js"
import style0 from "./user_item_step_devices.vue?vue&type=style&index=0&id=453d6853&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports